import { TResult } from './Result'

export function extractResultSuccessData<T> (list: Array<TResult<T>>): Array<T> {
  const successDataList = list
    .filter((item) => item.status === 'success')
    .map((item) => item.result)
  return successDataList
}
